<div class="ui-fluid">
    <p-autoComplete #manifestFileAutoComplete [(ngModel)]="manifestFile"
        (ngModelChange)="manifestFileChange.emit($event)" id="SingleSelectInput" [multiple]="multiple"
        [suggestions]="filteredManifestFiles" (completeMethod)="filterManifestFiles($event)" field="name"
        placeholder="{{l('ClientFileName')}}" [minLength]="1" name="SingleSelectInput" forceSelection="true" dropdown="true">
    </p-autoComplete>
</div>